"use client";

import { useRef, useState } from "react";
import { autoUpdate, offset, shift, useFloating } from "@floating-ui/react";
import { createPortal } from "react-dom";
import { cn } from "@/shared/lib/utils";
type OverflowTextProps = {
  children: string;
  className?: string;
};
const TOOLTIP_PADDING_X = 2;
export function OverflowText({
  children,
  className
}: OverflowTextProps) {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [open, setOpen] = useState(false);
  const {
    refs,
    floatingStyles
  } = useFloating({
    open,
    placement: "bottom-start",
    middleware: [offset(({
      rects
    }) => ({
      mainAxis: -rects.reference.height,
      crossAxis: -TOOLTIP_PADDING_X
    })), shift({
      padding: 8
    })],
    whileElementsMounted: autoUpdate
  });
  function handleMouseEnter() {
    const el = textRef.current;
    if (el && el.scrollWidth > el.clientWidth) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    setOpen(false);
  }
  return <>
      <span ref={node => {
      textRef.current = node;
      refs.setReference(node);
    }} className={cn("truncate", className)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </span>
      {open && createPortal(<span ref={refs.setFloating} style={floatingStyles} className={cn("bg-popover z-50 rounded-sm px-0.5 shadow-md ring-1 ring-black/5", className, "whitespace-normal")} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
          </span>, document.body)}
    </>;
}